<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <b-container v-else>

        <router-link class="admin-link" :to="{ path: `/Admin/Questions`, query: { 'api-Version': apiHeaders['api-Version'] } }">
            &larr; Перейти к списку вопросов
        </router-link>
        
        <div class="admin-title">{{header}}</div>

        <b-tabs content-class="mt-3">

            <!-- ОСНОВНАЯ ИНФОМАЦИЯ -->
            <b-tab class="no-focus" title="Основная информация">
                <b-row class="my-2" />

				<label for="QuestionName">Название вопроса</label>
				<b-form-input id="QuestionName"
							  v-model="entity.Name"
                              class="mb-13" />
                
                <label for="QuestionTechnicalName">Техническое название вопроса</label>
				<b-form-input id="QuestionTechnicalName"
							  v-model="entity.TechnicalName"
                              class="mb-13" />           

				<label for="QuestionPrompt">Подсказка</label>
				<b-form-textarea id="Prompt"
								 rows="2"
								 v-model="entity.Prompt"
								 placeholder="Введите подсказку для прохождения вопроса"
								 class="mb-13" />

                <b-row class="mb-13">

					<b-col cols="3" class="m-0 p-0">

						<label for="QuestionType">Тип</label>
						<custom-multiselect id="QuestionType"
											required
											placeholder="Выберите тип"
											v-model="entity.Type"
											:options="questionTypes"
											@select = "selectType"/>

					</b-col>

					<b-col class="ml-15 p-0">

						<label for="QuestionRequired">Обязательный?</label>
						<yes-no-input id="QuestionRequired"
									  v-model="entity.IsRequired" />

					</b-col>

                    <b-col v-if="isParentQuestion" class="p-0" cols="7">

                        <b-row class="m-0 p-0">
                            
                            <b-col  class="m-0 p-0">

                                <label for="QuestionPhotoRequired">Обязательно ли фото?</label>
                                <yes-no-input id="QuestionPhotoRequired"
                                            v-model="entity.IsPhotoRequired" />

                            </b-col>

                            <b-col v-if="entity.IsPhotoRequired" cols="8" class="m-0 p-0">

                                <label for="QuestionPhotoCategory">Категория фото</label>
                                <custom-multiselect id="QuestionPhotoCategory"
                                                    required
                                                    track-by="Id"
                                                    label="Name"
                                                    v-model="entity.PhotoCategoryId"
                                                    :options="photoCategories" />

                            </b-col>

                        </b-row>

                    </b-col>				
	
				</b-row>

                <b-row v-if="isParentQuestion" class="mb-13">

                    <label for="QuestionPlace">Местонахождение</label>
                    <custom-multiselect id="QuestionPlace"
                                        required
                                        v-model="entity.Place"
                                        :options="placeTypes" />
                </b-row>

				<b-row class="m-0">
					<b-col class="m-0 p-0">
						<label for="QuestionAnswerType">Тип ответа на вопрос</label>
						<custom-multiselect id="QuestionAnswerType"
											class="mb-13"
											v-model="entity.AnswerType"
											:options="answerTypes"
											@select="clearDefaultAnswer" />

					</b-col>
					<b-col cols="8"  
						   v-if="entity.AnswerType && ( entity.AnswerType.Id == 1 ||
                                                        entity.AnswerType.Id == 10 ||  
                                                        entity.AnswerType.Id == 11 || 
                                                        entity.AnswerType.Id == 12 ||
                                                        entity.AnswerType.Id == 20 ||  
                                                        entity.AnswerType.Id == 22 ||  
                                                        entity.AnswerType.Id == 21 ||
                                                        entity.AnswerType.Id == 40 || 
                                                        entity.AnswerType.Id > 100 )">

						<default-answer id="isDefaultAnswer" 
										v-model="entity.DefaultValue"
										:display-condition="entity.AnswerType.Id"
										:answer-options="entity.Options"/>
					</b-col>
				</b-row>	
            </b-tab>

            <!-- ВАРИАНТЫ ОТВЕТОВ НА ВОПРОСЫ -->
			<b-tab  class="no-focus"
				   title="Варианты ответов на вопрос"
				   v-if="isOptionsVisible">

                   <!-- Drag and Drop для ответов -->
				<draggable v-model="entity.Options" 
                           v-bind="{handle:'.handle', animation:150}">

                    <b-container class="p-0" 
                                 v-for="(item, index) in entity.Options"
                                 :key="index">
                                 
                        <b-row class="m-13-0">

                            <b-col cols="7" class="p-0">
                                <b-form-input v-model="item.Text"
                                              placeholder="Введите вариант ответа" />
                            </b-col>

                            <b-col class="pr-0">
                                <b-form-input v-model="item.Weight"
                                              type="number"
                                              placeholder="Вес ответа" />
                            </b-col>

                            <b-col cols="2">
                                <b-button block 
                                        class="draggable-button red" 
                                        @click="entity.removeOption(index)">
                                    Удалить
                                </b-button>
                            </b-col>

                            <b-col cols="1" class="sort-handle handle" />						
                        </b-row>
                    </b-container>

				</draggable>

                <b-row class="mt-13">
                    <b-col cols="3" class="p-0">
                        <b-button block 
                                  class="draggable-button green"
                                  @click="entity.addOption()">
                            Добавить вариант ответа
                        </b-button>
                    </b-col>
                </b-row>			

            </b-tab>

            <!-- УСЛОВИЯ ДЛЯ ВОПРОСА -->
			<b-tab class="no-focus" title="Условия для вопроса">

                <b-row class="p-0 mt-10">

					<label for="VisibleCondition">Условие:</label>
					<custom-multiselect id="VisibleCondition"
										:preselect-first="true"
										v-model="entity.VisibleCondition"
										:options="visibleConditionTypes" />
					<hr class="my-4" />

				</b-row>

                <edit-visible-policies v-model="entity.VisiblePolicies"
									   :branches="branches"
                                       :regions="regions"
									   :questions="filterQuestions"
									   :networks="networks"
									   :trade-point-types="ttTypes"
									   :question-options="allOptions"/>

            </b-tab>

            <!-- ЗАВИСИМОСТИ -->
			<b-tab class="no-focus" title="Зависимости" v-if="(entity.ReferenceQuestions && entity.ReferenceQuestions.length) ||
                                                              (entity.Blocks && entity.Blocks.length)">

                <b-table bordered 
                         v-if="entity.ReferenceQuestions && entity.ReferenceQuestions.length"
                         class="custom-table-list" 
                         :fields="questionFields" 
                         :items="entity.ReferenceQuestions">

                    <template v-slot:cell(QuestionId)="data">
                        <router-link class="custom-table-list-link" target="_blank" :to="{ path: `/Admin/Questions/Edit?id=${data.item.QuestionId}`, query: { 'api-Version': apiHeaders['api-Version'] } }">
                            {{ data.value }}
                        </router-link>
                    </template>            

                </b-table>

                <b-table bordered
                         v-if="entity.Blocks && entity.Blocks.length"
                         class="custom-table-list" 
                         :fields="blockFields" 
                         :items="entity.Blocks">

                    <template v-slot:cell(Name)="data">
                        <router-link class="custom-table-list-link" target="_blank" :to="{ path: `/Admin/Blocks/Edit?id=${data.item.Id}`, query: { 'api-Version': apiHeaders['api-Version'] } }">
                            {{ data.value }}
                        </router-link>
                    </template>

                </b-table>

            </b-tab>


        </b-tabs>

        <hr class="my-4"> 

        <b-row class="m-0">
            <b-col cols="2" class="p-0 mr-10">
                <b-button block
                          id="admin-btn-save"
                          class="admin-button"
                          @click="save">
                    Сохранить
                </b-button>
            </b-col>
            <b-col v-if="entity.Id" cols="2" class="p-0 mr-10">
                <b-button block
                          id="admin-btn-cancel"
                          class="admin-button"
                          @click="removeQuestion">
                    Удалить
                </b-button>
            </b-col>
            <b-col cols="2" class="p-0 mr-10">
                <b-button v-if="!entity.Id" block
                          id="admin-btn-duplicate"
                          class="admin-button"
                          @click="duplicateQuestionModal()">
                    Дублировать вопрос
                </b-button>
            </b-col>
        </b-row>
        <b-modal ref="modal-duplicateQuestion" hide-footer centered title="Дублировать вопрос">                    
                <b-container>
                    <b-row>
                        <custom-multiselect required
                                            v-model="duplicateQuestion"                 
                                            :options="allQuestions"                                 
                                            placeholder="Введите название вопроса" class="mb-20"/>
                    </b-row>
                    <b-row >
                        <b-col class="m-0 p-0">
                            <b-button block  
                                    class="btn-sub picker-color green" @click="duplicateQuestionSave(duplicateQuestion.Id)">
                                    Ок
                            </b-button>                                    
                        </b-col>
                        <b-col cols="6" class="m-0 p-0">
                            <b-button block  
                                    class="btn-sub picker-color red" 
                                    @click="closeModal()">
                                    Отмена 
                            </b-button>
                        </b-col>
                    </b-row>     
                </b-container>                  
            </b-modal> 

    </b-container>
</template>
<script>
import AllRoutes from '@/routes/all.routes'
import Consts from '@/store/models/consts/adminConsts'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'
import ApiHeaders from '@/store/models/ApiHeaders'

import YesNoInput from '@/components/shared/YesNoInput'
import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import DefaultAnswer from '@/components/admin/questions/DefaultAnswer'
import EditVisiblePolicies from '@/components/admin/questions/EditVisiblePolicies'

import QuestionEditModel from '@/store/models/admin/questions/QuestionEdit'

export default {
    computed: {
        filterQuestions() {
            if (this.entity == null || this.entity.Type === null)
                return [];

            if (this.entity.Type.Id === 1)
                return this.questions.ParentQuestions.filter(q => q.AnswerType < 100);
            else
                return this.questions.ParentQuestions.concat(this.questions.SubQuestions);
        },

        isOptionsVisible() {
            return this.entity.AnswerType !== null &&
                   this.entity.AnswerType.Id >= 20 &&
                   this.entity.AnswerType.Id < 23;
        },

        header() {
            return this.isCreate ? "Создание нового вопроса" : "Редактирование вопроса";
        },

        isParentQuestion() {
            return this.entity.Type !== null && this.entity.Type.Id === 1;
        }
    },

    data: function() {
        let entity;

        let apiHeaders = new ApiHeaders().mapToDto(this.$route.query['api-Version']);

        let load = new Loading();

        let id = Object.keys(this.$route.query).length 
                    ? this.$route.query.id 
                    : null;

        if(id)
            this.getInfo(load, id, apiHeaders);
        else {
            entity = new QuestionEditModel();
            this.getPhotoCategories(load);
        }
            
        this.getBranchesAndRegions(load);
        this.getNetworks(load);
        this.getAll(load, apiHeaders);
                
        return {
            load: load,
            id: id,
            entity: entity,
            isCreate: id == null,
            apiHeaders: apiHeaders,

            branches: [],
            regions: [],
            networks: [],            
            questions: [],
            allOptions: [],
            photoCategories: [],
            duplicateQuestion: [],
            allQuestions: [],
            

            ttTypes: Consts.TradePointTypes,
            questionTypes: Consts.QuestionTypes,
            placeTypes: Consts.PlaceTypes,
            answerTypes: Consts.AnswerTypes,
            visibleConditionTypes: Consts.VisibleConditionTypes,

            blockFields: [ { key: 'Name', label: 'Блоки вопросов' } ],
            questionFields: [
                {
                    key: 'QuestionId', 
                    label: 'Наименовнаие',
                    formatter: value => {
                        return this.questions.SubQuestions.find(e => e.Id == value).Text;
                    }
                },
                {   
                    key: 'VisibleCondition', 
                    label: 'Условие видимости',
                    formatter: value => {
                        return Consts.VisibleConditionTypes.find(e => e.Id == value).Text;
                    }
                },
                {   
                    key: 'ConditionType', 
                    label: 'Условие',
                    formatter: value => {
                        return Consts.ConditionTypes.find(e => e.Id == value).Text;
                    }
                }
            ]
        }
    },

    watch: {

        'entity.AnswerType': function (newVal, oldVal) {
            var oldIsMultiple = oldVal !== null &&
                typeof (oldVal) !== "undefined" &&
                oldVal.Id >= 20 &&
                oldVal.Id < 30;

            var newIsMultiple = newVal !== null &&
                newVal.Id >= 20 &&
                newVal.Id < 30;

            if (oldIsMultiple || (oldIsMultiple && newIsMultiple))
                while (this.entity.Options.length > 0)
                    this.entity.Options.pop();
        }

    },

    methods: {
        getInfo: function(load, id, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.Questions.Get(id, apiHeaders)
                .then(response => {
                    this.entity = new QuestionEditModel().mapFromDto(response.data);
                    this.getAllBlocks(load, apiHeaders);   
                    this.getPhotoCategories(load);                 
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getAllBlocks: function(load, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.Blocks.GetAll(apiHeaders)
                .then(response => {
                    this.entity.Blocks = response.data.filter(e => this.entity.Blocks.some(b => b == e.Id));
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getAll: function(load, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.Questions.GetAll(apiHeaders)
                .then(response => {
                    this.questions = response.data;
                    this.allQuestions = this.questions.ParentQuestions.concat(this.questions.SubQuestions);

                    load.Calculate(true);
                    apiService.Admin.Questions.GetAllOptions(apiHeaders)
                        .then(response => {
                            this.allOptions = response.data;
                            load.Calculate(false);

                            if(this.entity.VisiblePolicies && this.entity.VisiblePolicies.length) {
                                this.entity.VisiblePolicies.forEach(e => {
                                    if(e.ParentQuestionId)
                                        e.ParentQuestionId = this.allQuestions.find(q => q.Id == e.ParentQuestionId);
                                });
                                this.getValueForVisiblePolicies();
                            }
                        })
                        .catch(() => load.Calculate(false));

                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getBranchesAndRegions: function(load) {
            load.Calculate(true);

            apiService.Admin.Branches.GetTerritorialLinks()
                .then(response => {
                    this.branches = response.data.Branches;
                    this.regions = response.data.Regions;  
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getNetworks: function(load) {
            load.Calculate(true);

            apiService.Admin.TradePoints.GetNetworks()
                .then(response => {
                    this.networks = response.data;
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getPhotoCategories: function(load) {
            load.Calculate(true);

            apiService.Admin.PhotoCategories.GetAll()
                .then(response => {
                    this.photoCategories = response.data;

                    if(this.entity.PhotoCategoryId)
                        this.entity.PhotoCategoryId = response.data.find(e => e.Id === this.entity.PhotoCategoryId);

                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getValueForVisiblePolicies: function() {

            this.entity.VisiblePolicies.forEach(e => {
                    if(e.RelationType.Id == 1)
                        e.Value = e.getModelValueForAnswerType(this.allOptions);
                    else
                        e.Value = e.getModelTTValueForConditionType(this.branches, this.regions, this.networks, this.ttTypes);
                });              
        },

        save: function () {
            if (!this.entity.isValid()) {
                dialogService.showAlert('Предупреждение', 'Заполнены не все поля');
                return;
            }

            this.load.Calculate(true);

            var model = this.entity.mapToDto();

            apiService.Admin.Questions.PostUpdate(model, this.apiHeaders)
                .then(() => location.reload())
                .catch(() => this.load.Calculate(false));

        },

        removeQuestion: function () {
            this.load.Calculate(true);

            apiService.Admin.Questions.PostRemove(this.entity.Id, this.apiHeaders)
                .then(() => {
                    this.$router.push({ path: AllRoutes.Admin.Questions.Index, query: { "api-Version": this.apiHeaders['api-Version'] } });
                })
                .catch(() => this.load.Calculate(false));

        },

        duplicateQuestionModal: function () { 
            this.$refs['modal-duplicateQuestion'].show();
        },

        closeModal: function() {
            this.$refs['modal-duplicateQuestion'].hide();
            this.duplicateQuestion = [];
        },

        duplicateQuestionSave: function(id){ 
            this.getInfo(this.load, id, this.apiHeaders) 
            setTimeout(() => {
                this.entity.Id = Object.keys(this.$route.query).length 
                    ? this.$route.query.id 
                    : null;
                this.getAll(this.load, this.apiHeaders);
                this.entity.Options.forEach(e =>{ 
                    e.Id = null; 
                    e.OldId = null; 
                    e.QuestionId = null; })
                this.entity.Blocks = [];
                this.entity.ReferenceQuestions = [];
            }, 1000);  
        },

        selectType: function(value) {
            if (this.id != null && value == this.questionTypes[1]) {
                dialogService.showAlert( 'Информация', 'При смене типа вопроса, он будет удален из всех блоков вопросов. А так же будут удалены все зависимости от других вопросов к текущему');
            }
        },

        clearDefaultAnswer: function() {
            this.entity.DefaultValue = null;
        }
    },

    components: {
        Spinner,
        YesNoInput,
        CustomMultiselect,
        DefaultAnswer,
        EditVisiblePolicies
    }
    
}
</script>